<script lang="ts">
  import type { StoresKey } from "~/stores";
  export let request_store_key: StoresKey;
  const { T } = getStoresContext(request_store_key);
  import { createEventDispatcher } from "svelte";
  import { getStoresContext } from "~/stores";
  const dispatch = createEventDispatcher();
  function search(event: Event) {
    const { target } = event;
    if (target) {
      const search_value = (target as HTMLButtonElement).value;
      dispatch("search", search_value);
    }
  }
  $:t = $T
</script>

<section class="section pb-5">
  <div class="row mb-4">
    <div class="col-lg-8 col-12">
      <div class="position-relative">
        <input
          class="form-control input-with-icon"
          name="Search for store"
          placeholder="{t`search`}"
          on:input={search}
        />
       <img src="/theme/citycon2023/images/Search.png" class="icon-in-input" alt="search" width="32">
      </div>
    </div>
    <div class="col-lg-4 col-12 d-none">
      <div class="switch-wrapper mt-lg-0 mt-3">
        <span>{t`student offers`}</span>
        <label class="switch mx-2">
          <input type="checkbox" name="category" />
          <span class="slider round" />
        </label>
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  .switch-wrapper {
    display: flex;
    height: 100%;
    align-items: center;
    margin-top: 2rem;
    @media only screen and (min-width: 992px) {
      justify-content: flex-end;
      margin-top: 0;
    }
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 36px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border: 1px solid #000;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    left: 6px;
    bottom: 5px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    background: #000;
  }

  input:checked + .slider {
    background: #fff;
    border: 1px solid var(--color-dark-green);
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(22px);
    -ms-transform: translateX(22px);
    transform: translateX(22px);
    background: var(--color-dark-green);
  }

  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .input-with-icon {
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 0;
    padding-left: 0;
  }
  .icon-in-input {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(0, -50%);
  }

  input.form-control {
    background: none;
  }
</style>
